import { store } from "../../..";
import * as validate from "../../../../core/validation";
import { API } from "../../../../legacy/api";
import * as actions from "../../Header/Common/Header.actions";

API.on("home.available.set", (available: boolean) => {
  store.dispatch(actions.setHomeAvailable(available));
});

API.on("home.enabled.set", (enabled: boolean) => {
  store.dispatch(actions.setHomeEnabled(enabled));
});

API.on("plugin.available.set", (available: boolean) => {
  store.dispatch(actions.setPluginAvailable(available));
});

API.on("plugin.enabled.set", (enabled: boolean) => {
  store.dispatch(actions.setPluginEnabled(enabled));
});

API.on("pluginmenubutton.icon.set", (icon: string) => {
  if (validate.icon(icon)) {
    store.dispatch(actions.setMobilePluginMenuButtonIcon(icon));
  }
});
